(function() {
  document.addEventListener('alpine:init', () => {
    window.vars = window.vars || {};

    Alpine.data('styletileHeader', (initialValues) => {

      return {
        cartState: {
          items: initialValues.initialCartItems,
          qty: initialValues.initialCartQty
        },
        onAddToCart(e){
          console.log('header...', e);
          let incomingCartQty = 0;
          let items = [];
          let incomingVariantId;

          if('items' in e.detail.event.cartUpdates && Array.isArray(e.detail.event.cartUpdates.items)) {
            items = e.detail.event.cartUpdates.items;

            console.log(this.items)
            console.log(e.detail.event.cartUpdates.items)

            items.forEach((item) => {
              const variantId = item['variant_id'];
              const quantity = item.quantity;

              this.cartState.items[variantId] = quantity;
            });

            console.log(this.cartState.items)
          }

          const newQty = Object.values(this.cartState.items).reduce((prev, next) => {
            return prev + next;
          }, 0);

          this.cartState.qty = newQty;

          console.log('this.cartState.items', this.cartState.items)
          console.log('incomingCartQty', incomingCartQty)
        },
        onChangeToCart(e){
          console.log('header...', e);

          if('items' in e.detail.event.cartUpdates && Array.isArray(e.detail.event.cartUpdates.items)) {
            items = e.detail.event.cartUpdates.items;

            console.log(this.items)
            console.log(e.detail.event.cartUpdates.items)

            this.cartState.qty = items.reduce((prev,next) => {
              return prev + next.quantity
            }, 0);

            console.log(this.items)
          }

        }
      }
    })

  });

})();